// extracted by mini-css-extract-plugin
export default {"gap":".5em","theme":"#28a86e","wrapper":"PageTitle_wrapper__Vuwp8","title":"PageTitle_title__hbj-z","buttons":"PageTitle_buttons__CuG3+"};